<template>
  <div :style="normalizedStyle">
    <space :gutter="gutter">
      <slot></slot>
    </space>
  </div>
</template>

<script setup lang="ts">
import { computed, CSSProperties } from 'vue'
import type { ButtonGroupProps } from './ButtonGroup'
import Space from '../../Space'

defineOptions({ name: 'OButtongroup', inheritAttrs: false })

const { gutter, align = 'right', style } = defineProps<ButtonGroupProps>()
const normalizedStyle = computed<CSSProperties>(() => {
  return {
    textAlign: align,
    ...style
  }
})
</script>
